import { API_BASE_URL } from './config';
import { apiFetch, renderTransitWidget, renderError } from './helpers';
import type { BusDeparturesResponse } from './types';

export async function fetchBusDepartures(): Promise<void> {
    const container = document.getElementById('bus-departures');
    if (!container) return;

    try {
        const response = await apiFetch(`${API_BASE_URL}/busdepartures`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data: BusDeparturesResponse = await response.json();
        renderTransitWidget(container, data.alerts, data.departures, 'bus', 'Ei lähteviä busseja.');
    } catch (error) {
        renderError(container, 'bus', 'Could not load departures.', error);
    }
}
